module.exports = __webpack_public_path__ + "static/media/accessory18.b6da1a65.webp";